import React from "react";
import { Badge } from "@chakra-ui/react";
import { ALO_STATUSES, statusLabel } from "../format";

export default function StatusBadge({ status, ...rest }) {
  const color = (ALO_STATUSES[status] && ALO_STATUSES[status].color) || "gray";
  return (
    <Badge colorScheme={color} borderRadius="8px" px="8px" py="2px" textTransform="none" fontSize="xs" {...rest}>
      {statusLabel(status)}
    </Badge>
  );
}
